/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block}div[_ngcontent-%COMP%]{display:block;padding:16px;background-color:rgba(0,0,0,.04);cursor:pointer;height:100%;box-sizing:border-box;color:rgba(0,0,0,.54)}"];
export { styles as styles };
